module.exports = __webpack_public_path__ + "img/JE.6709730b.svg";